import { TranslationKey } from "../i18n/translation-key"
import { BikeForSaleStatus } from "./bike-for-sale-status"

export const BIKE_FOR_SALE_STATUS_LABEL_KEYS: Record<
  BikeForSaleStatus,
  TranslationKey
> = {
  [BikeForSaleStatus.CREATED]: "common.bikeForSaleStatus.created",
  [BikeForSaleStatus.TO_BE_SERVICED]: "common.bikeForSaleStatus.toBeServiced",
  [BikeForSaleStatus.WILL_NOT_BE_SERVICED]:
    "common.bikeForSaleStatus.willNotBeServiced",
  [BikeForSaleStatus.SERVICED]: "common.bikeForSaleStatus.serviced",
  [BikeForSaleStatus.BIKE_INFO_ADDED]: "common.bikeForSaleStatus.bikeInfoAdded",
  [BikeForSaleStatus.STORE_MATERIAL_CREATED]:
    "common.bikeForSaleStatus.storeMaterialCreated",
  [BikeForSaleStatus.ACCOUNTING_DOC_CREATED]:
    "common.bikeForSaleStatus.accountingDocCreated",
  [BikeForSaleStatus.SOLD]: "common.bikeForSaleStatus.sold",
  [BikeForSaleStatus.SCRAPPED]: "common.bikeForSaleStatus.scrapped",
  [BikeForSaleStatus.HANDED_OVER]: "common.bikeForSaleStatus.handedOver",
}

export const bikeForSaleStatusLabelKey = (
  status: BikeForSaleStatus,
): TranslationKey => BIKE_FOR_SALE_STATUS_LABEL_KEYS[status]
